
import { Component, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'

import {
  getResolve,
  postPatient,
  updatePatientStatus,
  updatePatient,
  getPatientsList
} from '@/components/patients/patients.service'
import { getResolve as Doc } from '@/components/admin/forms.service'
import {
  PaginationVM,
  Patient,
  PatientList,
  PatientVM,
  Role,
  SelectVM,
  UpdatePatientStatus
} from '@/models'
import moment from 'moment'
import {
  getCurrentUser,
  getHeadDoctor,
  getUserRole
} from '@/components/admin/users/users.service'
import { formatArrayBuffer } from '@microsoft/signalr/dist/esm/Utils'
// import { extend } from "vee-validate";

@Component({
  components: {
    Multiselect
  }
})
export default class PatientsView extends Vue {
  public expandAllRows = false
  public formExpanded = false
  public fields = [
    {
      key: 'expand',
      label: ''
    },
    {
      key: 'index',
      label: 'Index'
    },
    // {
    //   key: 'documentID',
    //   label: 'NPI',
    //   sortable: true
    // },
    {
      key: 'doctor',
      label: 'Doctor',
      sortable: true
    },
    {
      key: 'speciality',
      label: 'Speciality',
      sortable: true
    },

    {
      key: 'patient',
      label: 'Patient Name',
      sortable: true
    },
    {
      key: 'insuranceContractNo',
      label: 'Ins Contract No',
      sortable: true
    },
    {
      key: 'insuranceName',
      label: 'Insurance',
      sortable: true
    },

    {
      key: 'dob',
      label: 'DOB',
      formatter: 'formatDate',
      sortable: true
    },
    {
      key: 'age',
      label: 'Age',
      sortable: true
    },
    {
      key: 'sex',
      label: 'Sex',
      sortable: true
    },
    {
      key: 'phone',
      label: 'Phone 1',
      sortable: true,
      formatter: 'formatPhone'
    },
    // {
    //   key: 'mobile',
    //   label: 'Phone 2'
    // },

    {
      key: 'patientStatus',
      label: 'Status',
      sortable: true
    },

    {
      key: 'show_details',
      label: ''
    }
  ]
  public items: PatientList[] = []

  public insurances: SelectVM[] = []
  public insurancesPlans: SelectVM[] = []
  public selectedDoctor: SelectVM | null = null
  public doctorList: SelectVM[] = []
  public genders: SelectVM[] = []
  public searchQuery = ''
  public form = {} as PatientVM
  public isEditing = false
  public perPage = 10
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public currentUser = ''
  public searchLabel = 'Dr. Record ID, Patient or INS Contract No'
  public showDoctorSelection = false
  private dobInternal = ''
  public selectedInsurance: SelectVM | null = null

  @Watch('perPage')
  perPageChange() {
    this._getPatients()
  }

  get dobText(): string {
    const form: any = this.form
    const dob = form.dob
    if (dob) {
      const [year, month, day] = dob.split('-')
      return `${month.padStart(2, '0')}-${day.padStart(2, '0')}-${year}`
    }
    return this.dobInternal
  }

  set dobText(value: string) {
    this.dobInternal = value
    const form: any = this.form

    const trimmed = (value || '').trim()
    if (!trimmed) {
      this.$set(form, 'dob', null)
      return
    }

    // Try to parse common date formats explicitly and strictly
    const parsed = moment(
      trimmed,
      ['MM-DD-YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'],
      true
    )

    if (!parsed.isValid()) {
      this.$set(form, 'dob', null)
      return
    }

    // Always store DOB in ISO-like string format 'YYYY-MM-DD' for consistency
    const normalized = parsed.format('YYYY-MM-DD')
    this.$set(form, 'dob', normalized)
  }
  public formatPhone(digits: string): string {
    const clean = digits.replace(/\D/g, '').slice(0, 10) // just in case

    const p1 = clean.substring(0, 3)
    const p2 = clean.substring(3, 6)
    const p3 = clean.substring(6, 10)

    if (clean.length <= 3) return p1
    if (clean.length <= 6) return `(${p1}) ${p2}`
    return `(${p1}) ${p2}-${p3}`
  }
  public getLength(value) {
    return value ? value.toString().trim().length : 0
  }
  public getCustomLabel(e: any) {
    return `${e.documentId} - ${e.label}`
  }
  public async onPageChange(pageNumber: number) {
    this.expandAllRows = false
    await this._getPatients(pageNumber, this.searchQuery)
  }
  get _pagination() {
    return this.pagination
  }
  private async created() {
    const response = await getResolve()
    if (!response) return
    this.insurances = response.insurances.sort((a: SelectVM, b: SelectVM) =>
      a.label.localeCompare(b.label)
    )
    // this.genders = response.genders
    this.insurancesPlans = response.insurancePlans

    this.currentUser = getCurrentUser()
    if (getUserRole() == Role.Doctor || getUserRole() == Role.Staff) {
      this.hideDoctorInfo()
    } else if (getUserRole() == Role.DoctorStaff) {
      this.currentUser = getHeadDoctor()
      this.currentUser.userName = this.currentUser.documentId
      this.hideDoctorInfo()
    } else {
      this.searchLabel = '(Doctor Name, NPI, Patient or INS Contract No):'
      this.fields.splice(2, 0, {
        key: 'npi',
        label: 'NPI',
        sortable: true
      })
      this.showDoctorSelection = true
    }

    await this._getPatients()
  }

  public hideDoctorInfo() {
    this.fields = this.fields.filter(
      c => c.key != 'doctor' && c.key != 'speciality'
    )
  }
  public async cleanFilter() {
    this.searchQuery = ''
    await this._getPatients(1, this.searchQuery)
  }
  public async filter() {
    await this._getPatients(1, this.searchQuery)
  }
  public async toggleForm() {
    this.formExpanded = !this.formExpanded
    if (!this.formExpanded) {
      this.form = {} as PatientVM
      this.isEditing = false
      this.dobInternal = ''
      this.selectedDoctor = null
    } else {
      await this.fillFields()
    }
  }
  public toggleRow() {
    this.items = this.items.map(c => {
      return { ...c, _showDetails: !c._showDetails }
    })
    this.expandAllRows = !this.expandAllRows
  }
  private async _getPatients(pageNumber = 1, searchQuery = '') {
    const response = await getPatientsList(
      pageNumber,
      this.perPage,
      searchQuery,
      this.selectedInsurance?.label
    )
    this.items = response.data
    this.pagination = JSON.parse(response.headers['x-pagination'])
  }
  public formatDate(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY')
  }
  public async fillFields() {
    // if (!this.formExpanded) return
    const response = await getResolve()
    if (!response) return
    this.insurances = response.insurances.sort((a: SelectVM, b: SelectVM) =>
      a.label.localeCompare(b.label)
    )
    this.genders = response.genders
    this.insurancesPlans = response.insurancePlans
    const doc = await Doc()
    this.doctorList = doc.doctors
    // console.log(response)
  }
  public async edit(item: PatientVM) {
    await this.fillFields()
    this.isEditing = true

    const d = moment(item.dob)

    this.form = {
      ...item,
      dob: d.isValid() ? d.format('YYYY-MM-DD') : null
    } as PatientVM

    this.dobInternal = d.isValid() ? d.format('MM-DD-YYYY') : ''

    this.selectedDoctor = this.doctorList.filter(
      c => c.value == item.doctorId.toString()
    )[0]
    this.formExpanded = true
  }

  public stripPhoneMask(phone: string): string {
    return phone ? phone.replace(/[\s()-]/g, '') : null
  }
  public async create(): Promise<void> {
    const isValid = await (this.$refs.observer as any).validate()
    if (!isValid) {
      return
    }

    const form: any = this.form
    // Keep DOB as a string in 'YYYY-MM-DD' format to match PatientVM.dob: string
    const dobForApi = form.dob
      ? moment(form.dob, 'YYYY-MM-DD').format('YYYY-MM-DD')
      : null

    const obj = {
      ...this.form,
      phone: this.stripPhoneMask(this.form.phone),
      mobile: this.stripPhoneMask(this.form.mobile),
      dob: dobForApi,
      insuranceName: this.insurances.find(
        c => c.value == this.form.insuranceID.toString()
      )?.label,
      insurancePlan: this.insurancesPlans.find(
        c => c.value == this.form.planID.toString()
      )?.label,
      sex: this.genders.find(c => c.value == this.form.sexId.toString())?.label,
      doctorID: this.selectedDoctor ? +this.selectedDoctor.value : null,
      email2: null
    } as PatientVM

    if (!this.isEditing) {
      await postPatient(obj)
    } else {
      obj.patientID = this.form.patientID
      await updatePatient(obj)
    }
    this.isEditing = false
    this.formExpanded = false
    this.form = {} as PatientVM
    this.dobInternal = ''
    this._getPatients()
  }
  public changeStatus(checked: boolean, item: Patient) {
    this.$swal
      .fire({
        title: 'Are you sure?',
        text: `This patient status will be set as ${
          checked ? 'Active' : 'Inactive'
        }`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm'
      })
      .then((result): void => {
        if (result.isConfirmed) {
          const obj: UpdatePatientStatus = {
            doctorId: item.doctorId,
            documentID: item.documentID,
            statusValue: checked,
            patientID: item.patientID
          }

          updatePatientStatus(obj).then(c => {
            this._getPatients()
          })
          this.$swal.fire(
            `${checked ? 'Activated' : 'Deactivated'}!`,
            `The patient has been ${
              checked ? 'Activated' : 'Deactivated'
            } successfully`,
            'success'
          )
        } else {
          item.patientStatus = !item.patientStatus
        }
      })
  }
}
